<div style="padding:30px">
    <ul class="nav nav-tabs" style="margin: 10px 0 15px 0">
        <li *ngFor="let item of menu_list;let i = index" class="nav-item"  style="cursor:pointer"  (click)="choose(item.id)">
          <span   [ngClass]="now==item.id?'active':''" class="nav-link" href="#">{{item.name}}</span>
        </li>
    </ul>
    <div>

        區間動態
        <app-date [type]="true"  [time]="time" [timeset]="timeset" (rangeSelected)="handleRangeSelected($event)"></app-date>

        <select class="form-control"
        style="width: 160px;display: inline-block;"
        [(ngModel)]="tool_obj.lock_status"
        (change)="init_list()"
        >
        <option default disabled value="-2">動態種類</option>
        <option *ngFor="let item of lock_option_list" [ngValue]="item.id">{{item.name}}</option>
        </select>
        <select class="form-control"
        style="width: 160px;display: inline-block;"
        [(ngModel)]="tool_obj.gender_action"
        (change)="init_list()"
        >
        <option default disabled value="-2">性別</option>
        <option *ngFor="let item of gender_option_list" [ngValue]="item.id">{{item.name}}</option>
        </select>

        <select class="form-control" *ngIf="now == '3' || now == '4' "
        style="width: 160px;display: inline-block;"
        [(ngModel)]="check_status_action"
        (change)="init_list()"
        >
        <option default disabled value="-2">審核狀態</option>
        <option *ngFor="let item of check_status_list" [ngValue]="item.id">{{item.name}}</option>
        </select>


        <select class="form-control"
        style="width: 160px;display: inline-block;"
        [(ngModel)]="tool_obj.identity_action"
        (change)="init_list()"
        >
        <option default disabled value="-2">身分</option>
        <option *ngFor="let item of identity_option_list" [ngValue]="item.id">{{item.name}}</option>
        </select>

        <select class="form-control"
        style="width: 160px;display: inline-block;"
        [(ngModel)]="tool_obj.type"
        (change)="init_list()"
        >
        <option default disabled value="-2">顯示類型</option>
        <option *ngFor="let item of type_option_list" [ngValue]="item.id">{{item.name}}</option>
        </select>


        <select class="form-control" *ngIf="tool_obj.identity_action == 3"
        style="width: 160px;display: inline-block;"
        [(ngModel)]="manage_action"
        (change)="init_list()"
        >
        <option *ngFor="let item of manage_option_list" [ngValue]="item.id">{{item.name}}</option>
        </select>

        <select class="form-control"
        style="width: 160px;display: inline-block;"
        [(ngModel)]="tool_obj.chosen1_action"
        (change)="init_list()"
        *ngIf="now*1 == 4"
        >

        <option default disabled value="-3">精選種類</option>
        <option *ngFor="let item of chosen_option_list" [ngValue]="item.id">{{item.name}}</option>
        </select>
        <input type="text" placeholder="查詢使用者"  style="width: 160px;display: inline-block;"
        class="form-control"  [(ngModel)]="tool_obj.search_model"
        (keyup.enter)="init_list()">
        <button class="btn btn-primary" (click)="init_list()">確認</button>
        <div>
            <button class="btn btn-primary" style="margin: 4px;" (click)="choose_all(1)">全選</button>
            <button class="btn btn-primary" style="margin: 4px;" (click)="choose_all(0)">取消全選</button>
        </div>
    </div>
    <hr>

    <div  *ngIf="now=='2'" class="card  bg-light mb-3 " style="margin-top:10px">
        <div class="card-header">數據</div>
        <div class="card-body">
            <div class="card-text top_info_num">全部未審：<span class="show_it">{{top_info.all_0|number}}</span></div>
            <div class="card-text top_info_num">全部精選：<span class="show_it">{{top_info.all_1|number}}</span></div>
            <div class="card-text top_info_num">全部非精選：<span class="show_it">{{top_info.all_m1|number}}</span></div>
            <div class="card-text top_info_num">區間未審：<span class="show_it">{{top_info.time_0|number}}</span></div>
            <div class="card-text top_info_num">區間精選：<span class="show_it">{{top_info.time_1|number}}</span></div>
            <div class="card-text top_info_num">區間非精選：<span class="show_it">{{top_info.time_m1|number}}</span></div>
        </div>
    </div>
    <div  *ngIf="now=='3'||now=='4'" class="card  bg-light mb-3 " style="margin-top:10px">
        <div class="card-header">數據</div>
        <div class="card-body">
            <div class="card-text top_info_num">全部未審：<span class="show_it">{{top_info.all_0|number}}</span></div>
            <div class="card-text top_info_num">全部已審：<span class="show_it">{{top_info.all_1|number}}</span></div>

            <div class="card-text top_info_num">區間未審：<span class="show_it">{{top_info.time_0|number}}</span></div>
            <div class="card-text top_info_num">區間已審：<span class="show_it">{{top_info.time_1|number}}</span></div>

        </div>
    </div>


    <!-- 提示文字 -->
    <div style="margin-top: 5px; font-size: 12px;margin-bottom: 10px; color: #6c757d;">
        盜圖的排程更新時間是每小時17分
    </div>

    <div *ngFor="let area of data;let bi = index" >
        <h3>{{area.date}}</h3>
        <hr>
        <div *ngFor="let item of area.data;let i = index; trackBy: trackByFn"
         class="card  bg-light mb-3 info_item {{tool_obj.process_list.indexOf(item.id)!=-1?'choose_item':''}}  {{alert_list.indexOf(item.id)!=-1?'alert_item':''}}  {{alert_pic_list.indexOf(item.id)!=-1?'alert2_item':''}}" >
            <div class="tagntndiv" style="height: 43px;">
                <button class="tag btn btn-danger" *ngIf="item.diamond!=0">上鎖</button>
                <button class="tag btn btn-secondary" *ngIf="item.is_enable<0 && item.is_enable != -99">下架</button>
                <button class="tag btn btn-secondary" *ngIf="item.is_enable==-99">盜圖下架</button>
                <button class="tag btn btn-secondary" *ngIf="item.is_enable==6">盜圖</button>
                <button class="tag btn btn-success" *ngIf="item.is_chosen==1">精選</button>
                <button class="tag btn btn-success" *ngIf="item.is_chosen==-1">非精選</button>
                <!-- <button class="tag btn btn-info" *ngIf="item.validate_employee_id != 0">已審核</button>    -->
            </div>
            <div class="info_itemsss">
                <div class="card-header" (click)="choose_item(item);alert_item(item,0,0)"  style="cursor: pointer;">
                    <img loading="lazy" *ngIf="item.type*1==3" style="width: 100%;" src="{{item.url}}">
                    <img loading="lazy" *ngIf="item.type*1==4" style="width: 100%;" src="{{item.preview_url}}">
                </div>

                <div class="card-body">
                    <div class="card-text">
                        <span class="{{item.gender==1?'boy':'girl'}}">用戶：</span><a target="_blank" href="{{link}}/useractive/{{item.uid}}"><span class="user_identity_{{item.identity}}">{{item.name}}
                            <div *ngIf="item.v_name.length>0">({{item.v_name}})</div>
                        </span></a>
                    </div>
                    <div class="card-text">
                        鑽石：
                        <span *ngIf="item.diamond>=0">{{item.diamond?item.diamond:0}}</span>
                        <span *ngIf="item.diamond<0">男生上鎖</span>
                    </div>
                    <div class="card-text">
                        動態描述：{{item.description}}
                    </div>
                    <div class="card-text">
                        動態類型：{{item.type==4?'影片':'圖片'}}
                    </div>
                    <div class="card-text">
                        觀看次數：{{item.view?item.view:0}}
                    </div>
                    <div class="card-text" *ngIf="item.validate_employee_id == 0  && item.auto_validate == 0">
                        最後處理人：-
                    </div>
                    <div class="card-text" *ngIf="item.validate_employee_id != 0 ">
                        最後處理人：{{item.emp_name}}
                    </div>
                    <div class="card-text" *ngIf="item.auto_validate != 0 ">
                        最後處理人：自動審核
                    </div>
                    <div class="card-text">
                        <a href="{{item.url}}" target="_blank">分頁觀看</a>
                    </div>
                    <div class="card-text" *ngIf="item.is_chosen == 1">
                        <label for="datetime">選擇發送日期:</label>
                        <input type="datetime-local" id="datetime" name="datetime"  [(ngModel)]="item.selectedDateTime" required *ngIf="item.timetype == 3">
                        <input type="date" id="datetime" name="datetime"  [(ngModel)]="item.selectedDateTime" required *ngIf="item.timetype != 3">
                    </div>
                    <div class="card-text" *ngIf="item.is_chosen == 1">
                        <p>預期審核時間:</p>
                        <button  [ngClass]="item.timetype == 1?'tag btn btn-danger':'tag btn btn-secondary'" (click)="item.timetype = 1">8點</button>
                        <button  [ngClass]="item.timetype == 2?'tag btn btn-info':'tag btn btn-secondary'"  (click)="item.timetype = 2">12點</button>
                        <button  [ngClass]="item.timetype == 3?'tag btn btn-success':'tag btn btn-secondary'"  (click)="item.timetype = 3">自訂時間</button>
                    </div>


                    <div class="card-text" *ngIf="item.is_enable==-99">
                        <p>佐證圖上傳:</p>

                        <app-img-cropper [ntype]="1" [editData]="item.checkUrl" (imageUpload)="handleImageUpload($event,bi,i)"></app-img-cropper>

                    </div>

                    <div class="card-text" *ngIf="item.is_enable==6">
                        <p>佐證圖上傳:</p>

                        <app-img-cropper [ntype]="1" [editData]="item.checkUrl" (imageUpload)="handleImageUpload($event,bi,i)"></app-img-cropper>

                    </div>


                </div>
            </div>
        </div>

    </div>

    <div *ngIf="data.length==0">無資料</div>
    <div class="back-to-top show_mb_data">
        <div style="display: flex;flex-flow: column;">
            <div style="display: flex;flex-direction: column;align-items: revert;" *ngFor="let item of process_option_list">
                <button (click)="middle_save(item)" style="margin-bottom: 5px;" class="btn btn-secondary">{{item.name}}</button>
            </div>
            <div><button class="btn btn-primary" (click)="save()">送出審核結果</button></div>
            <a style="margin: 10px;cursor: pointer;text-align: center;" (click)="go_top()" id="go_top" onclick="return false">
                <i style="font-size: 1.73em;" class="fas fa-arrow-circle-up"></i>
            </a>
        </div>

        <!-- 其他按鈕和元素保持不變 -->

    </div>

    <app-pagnation (callback)="callback($event)" [data]="pageobjstr"></app-pagnation>
    <app-spinner [loading]="loading"></app-spinner>
</div>
